exports.baseURL = "https://host-api.tikkiearn.com/";
exports.key = "2<<[+2?-p!UzIWGm";
exports.projectName = "tikkiearn";
